import { inject, Injectable } from '@angular/core';
import { DynamicScript } from '../../shared/services/dynamic-script.service';
import { environment } from 'src/environments/environment';
declare var google: any;
@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  private loadScript = inject(DynamicScript);
  private initialized = false;

  init(callback: any) {
    if (this.initialized) return;
    this.initialized = true;
    this.loadScript.loadGoogleOneTap().then(() => {
      google.accounts.id.initialize({
        client_id: environment.clientId,
        callback: callback,
        auto_select: false,
        cancel_on_tap_outside: true
      });

      // google.accounts.id.prompt();
    }).catch(() => {
      this.initialized = false;
    });
  }

  showOneTap() {
    if (typeof google === 'undefined' || !google?.accounts?.id?.prompt) {
      return;
    }
    google.accounts.id.prompt();
  }

  renderButton(element: HTMLElement, isDesktop: boolean) {
    google.accounts.id.renderButton(element, {
      theme: 'outline',
      size: 'large',
      width: isDesktop ? '792px' : '250px',
      text: 'signin_with'
    });
  }
}
